import { Component, OnInit } from "@angular/core";
import { DocumentsService } from "src/app/services/document.service";
import { environment } from "../../../environments/environment";
import Swal from "sweetalert2";
import { CognitoService } from "src/app/services/cognito.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

declare var $: any;

@Component({
  selector: "app-mi-perfil",
  templateUrl: "./mi-perfil.component.html",
  styleUrls: ["./mi-perfil.component.css"],
})
export class MiPerfilComponent implements OnInit {
  loading: boolean = false;
  userEmail: string = "";
  userData: any = {};

  FormPasswordReset: FormGroup;

  constructor(
    private cognitoService: CognitoService,
    private documentService: DocumentsService,
    private fb: FormBuilder
  ) {
    this.userEmail = localStorage.getItem("email");

        this.FormPasswordReset = this.fb.group
        ({
            password: ['', [Validators.required,  Validators.minLength(6), this.passwordValidator]],
            confirmPassword: ['', [Validators.required]],
            code: ['', [Validators.required]]
        })

  }

  ngOnInit(): void {
    $('#sidebar-overlay').click();

    this.loadProfile();
  }

  loadProfile() {
    this.loading = true;
    this.documentService
      .getDocumentContainer(environment.businessId, this.userEmail)
      .subscribe({
        next: (data: any) => {
          this.userData = data;
          console.log("Profile data loaded", this.userData);
        },
        error: (error) => {
          this.loading = false;
          console.log("Error loading profile data", error);
        },
        complete: () => {
          this.loading = false;
        },
      });
  }

  updateProfile() {
    this.loading = true;

    this.documentService
      .updateDocumentContainer(
        environment.businessId,
        this.userEmail,
        "usuarios",
        null,
        this.userData
      )
      .subscribe({
        next: (data: any) => {
          console.log("Profile data updated", data);
          Swal.fire({
            title: "Perfil actualizado",
            text: "Los datos de tu perfil se han actualizado correctamente",
            icon: "success",
            confirmButtonText: "Aceptar",
          });
        },
        error: (error) => {
          console.log("Error updating profile data", error);
          Swal.fire({
            title: "Error",
            text: "Ha ocurrido un error al actualizar los datos de tu perfil",
            icon: "error",
            confirmButtonText: "Aceptar",
          });
        },
        complete: () => {
          this.loading = false;
        },
      });
  }

  sendPasswordResetEmail() {
    this.loading = true;
    this.cognitoService
      .forgotPassword(this.userEmail)
      .then(() => {
        this.loading = false;
      })
      .catch((error: any) => {
        console.log("Error sending password reset email", error);
      });
  }

  submitPasswordReset() {
    this.loading = true;

    this.cognitoService.forgotPasswordSubmit(
      this.userEmail,
      this.FormPasswordReset.value.code,
      this.FormPasswordReset.value.password
    ).then(() => {
      this.loading = false;

      // CLOSE MODAL AND RESET FORM
      $('#modalPassword').modal('hide');
      this.FormPasswordReset.reset();

      Swal.fire({
        title: "Contraseña actualizada",
        text: "Tu contraseña ha sido actualizada correctamente",
        icon: "success",
        confirmButtonText: "Aceptar",
      })
    }).catch((error: any) => {
      console.log("Error updating password", error);
      Swal.fire({
        title: "Error",
        text: "Ha ocurrido un error al actualizar tu contraseña",
        icon: "error",
        confirmButtonText: "Aceptar",
      })
    })
  }

  // UTILS

  passwordValidator(control: any): { [key: string]: boolean } | null {
    const password = control.value || '';
    const hasNumber = /\d/.test(password); // Verifica si contiene un número
    const hasUpperCase = /[A-Z]/.test(password); // Verifica si contiene una letra mayúscula
    const hasLowerCase = /[a-z]/.test(password); // Verifica si contiene una letra minúscula

    if (!hasNumber || !hasUpperCase || !hasLowerCase) {
    return { invalidPassword: true };
    }
    return null;
}
}
